/*eslint-disable */
/**
 * Global imports
 */
import svg4everybody from 'svg4everybody';
import MobileMenu from './components/mobile-menu';
import faq from './components/faq';
import Animations from './global/animations';
import PopUp from './components/popup';

document.addEventListener('DOMContentLoaded', () => {
	svg4everybody();
	MobileMenu();

	document.querySelector('body').classList.add('loaded');

	if (document.getElementsByClassName('block-animation').length === 0) {
		document.querySelector('body').classList.add('no-slides');
		document.querySelector('main').classList.add('no-slides');
	}

	// Check if .faq exists
	if (document.querySelector('.faq')) {
		faq();
	}

	// Check if .block-animation exists
	if (document.querySelector('.block-animation')) {
		Animations();
	}

	// Check if .poup blosck is active
	if (document.querySelector('.block-popup-is-active')) {
		PopUp();
	}


});
